import React from 'react';
import './configuration-detail.css';
import LoadingSpinner from '../components/LoadingSpinner';
import Constants from '../flux/Constants';

const globalStyle = `
html,
body,
#root,
.app {
    overflow: initial !important; // 1. Override app.css
    height: auto !important; // 1.
}
`;

// check if two arrays are equals
const equals = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export default class ConfigurationDetail extends React.Component {
  state = {
    requestStatus: 'loading',
    requestStatusParts: 'loading',
    customProduct: null,
    parts: null
  };

  componentDidMount() {
    // @todo 2020-02-10
    //   This should be moved inside a Flux store but given the type of page, we
    //   leave it as is, until there is a reason to refactor or it becomes
    //   convenient.
    fetch(`${Constants.BASE_URL}/custom-product/export/product/${this.props.match.params.code}`, {
      headers: {
        'accept': 'application/json',
      }
    })
      .then(response => response.json())
      .then(response => {
        this.setState({
          requestStatus: 'ready',
          customProduct: response,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({ requestStatus: 'error' });
      });

    fetch(`${Constants.BASE_URL}/get-product-parts/${this.props.match.params.code}`, {
      headers: {
        'accept': 'application/json',
      }
    })
      .then(response => response.json())
      .then(response => {
        this.setState({
          requestStatusParts: 'ready',
          parts: response,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({ requestStatusParts: 'error' });
      });

  }

  componentDidUpdate() {
    if(this.state.requestStatus === 'ready' && this.state.requestStatusParts === 'ready') {

      let arrayProductParts = [];
      let arrayCustomProductParts = [];

      this.state.parts.map(part => (
        arrayProductParts.push(part)
      ));
      this.state.customProduct.custom_product_parts.map(part => (
        arrayCustomProductParts.push(part.part)
      ));

      if( !equals(arrayProductParts, arrayCustomProductParts) ) {
        console.log('Custom product parts missing some product parts');
      }
    }
  }

  getPerforation(customProduct){
    if(customProduct.product.perforable === null){
      return (customProduct.perforated === 1) ? 'Perforated' : 'Not perforated'
    }else{
      return (customProduct.product.perforable === 1) ? 'Perforated' : 'Not perforated'
    }
  }

  render() {
    return (
      <div className="purchase-recap">
        {
          // Not the most elegant solution for global styles, but should do for
          // now.
          React.createElement('style', null, globalStyle)
        }
        {this.state.requestStatus === 'loading' ? (
          <div className="loading-spinner-container">
            <LoadingSpinner isVisible={true} text="Loading custom product…" />
          </div>
        ) : this.state.requestStatus === 'error' ? (
          <div className="notice-container">
            <p>There was an error retrieving the customization.</p>
          </div>
        ) : this.state.customProduct === null ? (
          <div className="notice-container">
            <p>An unexpected error occurred.</p>
          </div>
        ) : (
          <div className="purchase-recap-container">
            <div>
              <h2 className="pageTitle">Code: {this.state.customProduct.custom_product_hash}</h2>
              <h3>{this.state.customProduct.product.name}</h3>
              <div className="perofrated-info">Perforation: { this.getPerforation(this.state.customProduct) }</div>

              <div className="product-preview">
                <div>
                  <div>
                    <img src={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_front.id}`} alt="Front" />
                  </div>
                  <a href={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_front.id}`} download target="_blank">
                    Download (Front)
                  </a>
                </div>
                <div>
                  <div>
                    <img src={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_left.id}`} alt="Left side" />
                  </div>
                  <a href={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_left.id}`} download target="_blank">
                    Download (Left side)
                  </a>
                </div>
                <div>
                  <div>
                    <img src={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_back.id}`} alt="Back" />
                  </div>
                  <a href={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_back.id}`} download target="_blank">
                    Download (Back)
                  </a>
                </div>
                <div>
                  <div>
                    <img src={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_right.id}`} alt="Right side" />
                  </div>
                  <a href={`${Constants.BASE_URL}/resource/${this.state.customProduct.preview_image_right.id}`} download target="_blank">
                    Download (Right side)
                  </a>
                </div>
              </div>
            </div>
            {this.state.customProduct.custom_fitted === 0 && (
            <section>
              <h2>Additional Infos</h2>
              <table>
                <thead>
                  <th>Size</th>
                  <th>Size Type</th>
                </thead>
                <tbody>
                  <tr>
                    <td>{this.state.customProduct.size}</td>
                    <td>{this.state.customProduct.size_type}</td>
                  </tr>
                </tbody>
              </table>
            </section>
            )}
            <section>
              <h2>Parts</h2>
              <table>
                <thead>
                  <th>Name</th>
                  <th>Color</th>
                </thead>
                <tbody>
                  {Object.values(this.state.customProduct.custom_product_parts).length === 0 ? (
                    <tr>
                      <td colSpan={2}><i>None</i></td>
                    </tr>
                  ) : Object.values(this.state.customProduct.custom_product_parts).map((part, i) => (
                    <tr key={i}>
                      <td>{part.part}</td>
                      <td>{part.material}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>

            <section>
              <h2>Accessories</h2>
              <table>
                <thead>
                  <th>Name</th>
                  <th>Color</th>
                </thead>
                <tbody>
                  {Object.values(this.state.customProduct.custom_product_accessories).length === 0 ? (
                    <tr>
                      <td colSpan={2}><i>None</i></td>
                    </tr>
                  ) : Object.values(this.state.customProduct.custom_product_accessories).map((accessory, i) => (
                    <tr key={i}>
                      <td>{accessory.code}</td>
                      <td>{accessory.material}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>

            <section>
              <h2>Custom patches</h2>
              <table>
                <thead>
                  <th>Name</th>
                  <th>Preview</th>
                  <th />
                </thead>
                <tbody>
                  {Object.values(this.state.customProduct.custom_product_custom_patch).length === 0 ? (
                    <tr>
                      <td colSpan={3}><i>None</i></td>
                    </tr>
                  ) : Object.values(this.state.customProduct.custom_product_custom_patch).map((patch, i) => (
                    <tr key={i}>
                      <td>{patch.custom_patch}</td>
                      <td>
                        <div className="custom-patch-preview">
                          <a href={patch.image.url} target="_blank">
                            <img src={patch.image.url} alt="" />
                          </a>
                        </div>
                      </td>
                      <td>
                        <a href={`${Constants.BASE_URL}/resource/${patch.image.id}`} download target="_blank">Download</a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConfigurationDetail.js